<template>
  <Produtos
    ref="produtosRef"
    :Edicao="Edicao"
    :nomeAbaProdutos="nomeAbaProdutos"
    tipoCliente="Pessoa Jurídica"
  />
</template>

<script>
import Produtos from "../Shared/Produtos.vue";

export default {
  name: "CadastroPJ_Produtos",
  props: ["Edicao", "nomeAbaProdutos"],
  components: { Produtos },
  methods: {
    proximaEtapa() {
      this.$refs.produtosRef.proximaEtapa();
    },
    validarFormulario() {
      return this.$refs.produtosRef.validarFormulario();
    },
  },
};
</script>
